__turbopack_context__.v({
  "tab": "DiscoverTabs-module-scss-module__mix0aq__tab",
  "tabs": "DiscoverTabs-module-scss-module__mix0aq__tabs",
});
